// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as DownloadDDefault } from '../../../../../ui-v3/src/assets/icons/default/general/download-d.svg?react';
import { ReactComponent as DownloadDSolid } from '../../../../../ui-v3/src/assets/icons/solid/general/DOWNLOAD-D.svg?react';
import { createIcons } from '../../Icon';
const DownloadDIcon = /* @__PURE__ */ createIcons('DownloadD', {
    default: DownloadDDefault,
    solid: DownloadDSolid
});
DownloadDIcon.supportedTypes = [
    'default',
    'solid'
];
DownloadDIcon.category = 'general';
export default DownloadDIcon;
